<template>
  <div class="container-fluid">
    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(onSubmit)">
        <ValidationProvider
          :name="$t('modal.form.name.label')"
          rules="required"
          v-slot="{ errors }"
        >
          <label>
            {{ $t("modal.form.name.label") }}
            <input
              v-model="form.name"
              type="text"
              :placeholder="$t('modal.form.name.placeholder')"
            />
            <span class="text-danger">{{ errors[0] }}</span>
          </label>
        </ValidationProvider>

        <ValidationProvider
          :name="$t('modal.form.description.label')"
          rules="required"
          v-slot="{ errors }"
        >
          <label>
            {{ $t("modal.form.description.label") }}
            <input
              v-model="form.description"
              type="text"
              :placeholder="$t('modal.form.description.placeholder')"
            />
            <span class="text-danger">{{ errors[0] }}</span>
          </label>
        </ValidationProvider>

        <ValidationProvider
          :name="$t('modal.form.name_ru.label')"
          rules="required"
          v-slot="{ errors }"
        >
          <label>
            {{ $t("modal.form.name_ru.label") }}
            <input
              v-model="form.name_ru"
              type="text"
              :placeholder="$t('modal.form.name_ru.placeholder')"
            />
            <span class="text-danger">{{ errors[0] }}</span>
          </label>
        </ValidationProvider>

        <ValidationProvider
          :name="$t('modal.form.description_ru.label')"
          rules="required"
          v-slot="{ errors }"
        >
          <label>
            {{ $t("modal.form.description_ru.label") }}
            <input
              v-model="form.description_ru"
              type="text"
              :placeholder="$t('modal.form.description_ru.placeholder')"
            />
            <span class="text-danger">{{ errors[0] }}</span>
          </label>
        </ValidationProvider>

        <label>
          {{ $t("modal.form.image.label") }}
          <input type="file" @change="getImage" />
        </label>

        <label class="mb-3 d-flex align-items-center">
          <p class="mb-0 me-3">{{ $t("modal.form.should_return.label") }}</p>
          <input class="ms-3" type="checkbox" v-model="form.should_return" />
        </label>

        <b-button class="float-end ms-3" variant="primary" type="submit" :disabled="db">
          {{ $t("modal.button.post") }}
        </b-button>

        <b-button class="float-end" variant="warning" @click="onClose">
          {{ $t("modal.button.back") }}
        </b-button>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import { postInfo } from "../../../api/endpoints/info";
import { listMixin } from "../../../mixins/listMixin";

const req = {
  post: postInfo,
};

export default {
  name: "InfoPostModal",
  mixins: [listMixin],
  data() {
    return {
      req,
      form: {
        name: "",
        description: "",
        name_ru: "",
        description_ru: "",
        should_return: false,
      },
      changeImage: null,
      fd: new FormData(),
      db: false,
    };
  },
  methods: {
    onClose() {
      this.$emit("onClose");
    },
    onSubmit() {
      this.db = true;
      setTimeout(() => {
        this.db = false;
      }, 700)
      for (let label in this.form) {
        this.fd.append(label, this.form[label]);
      }
      this.fd.append("image", this.changeImage[0]);
      /*--------*/
      this.onPost();
    },
    getImage(event) {
      this.changeImage = event.target.files;
    },
  },
};
</script>
